import { gql } from "@apollo/client";

export const SEND_EMAIL = gql`
  mutation SendEmail(
    $test: [String!]
    $template: String
    $subject: String!
    $from: String!
    $emails: [String!]
    $message: String!
  ) {
    sendEmail(
      test: $test
      template: $template
      subject: $subject
      from: $from
      emails: $emails
      message: $message
    )
  }
`;
